(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.matchheight = {
    attach: function (context, settings) {

      // https://github.com/liabru/jquery-match-height
      $('.block-views-blockarticles-block-1 .views-row').matchHeight();
      $('.block-views-blockarticles-block-2 .views-row').matchHeight();

    }
  };

})(jQuery, Drupal, this, this.document);
